/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { ContactFormContent } from "src/modules/pe-landing-module/data/interfaces"

/* Protopia Ecosystem component */
export interface ICFAnimatedBorderProps {  
   primitive: ContactFormContent
}
const CFAnimatedBorder = (props: ICFAnimatedBorderProps): JSX.Element => {
    useEffect(() => {
        addCSSClass(
            `cf-border-${ props.primitive.id }`,
            `.cf-border-${ props.primitive.id }:before {
                width: ${props.primitive.overlayButtonSize}px; 
                height: ${props.primitive.overlayButtonSize}px;                
                border-radius: ${props.primitive.overlayBorder?.borderRound?.border}px; 
                border-color: ${props.primitive.overlayBg || "var(--force-plain-color)"}; 
            }
            .cf-border-${ props.primitive.id }:after {
                width: ${props.primitive.overlayButtonSize}px; 
                height: ${props.primitive.overlayButtonSize}px;                
                border-radius: ${props.primitive.overlayBorder?.borderRound?.border}px; 
                border-color: ${props.primitive.overlayBg || "var(--force-plain-color)"}; 
            }`
        )
        return () => {
            removeCSSClass( `cf-border-${ props.primitive.id }` )
        }
    }, []) 
    
    return !!props.primitive.overlayBacklightAnimation
        ?
        <>
            <div 
                className={`pe-cf-animated-border cf-border-${ props.primitive.id }`} 
                style={{  
                    width: props.primitive.overlayButtonSize, 
                    height: props.primitive.overlayButtonSize,                
                    borderRadius:props.primitive.overlayBorder?.borderRound?.border, 
                    borderColor: props.primitive.overlayBg || "var(--force-plain-color)", 
                }}
            /> 
        </>
        :
        <></>
}
export default CFAnimatedBorder